module.exports = __webpack_public_path__ + "static/media/suggestedToFriends_750_1000.e6773cd6.png";